export default __webpack_public_path__ + "static/fft_analysis-783caa6c6c0d4991c19358969cfa4a27.png";